import { lucideIcons } from '@round/creatorbase-ui';
import cn from 'classnames';
import styles from './PoolOption.module.css';

const { CheckIcon } = lucideIcons;

type Props = {
    name: string;
    description: string;
    memberCount: number;
    isMember: boolean;
};

const PoolOption = ({ name, description, memberCount, isMember }: Props) => {
    return (
        // The combobox item owns the click, so an already-joined row is made inert here
        <div className={cn(styles.option, { [styles.optionDisabled]: isMember })} aria-disabled={isMember}>
            <div className={styles.text}>
                <span className={styles.name}>{name}</span>
                {description && <span className={styles.description}>{description}</span>}
            </div>

            {isMember ? (
                <CheckIcon className={styles.memberIcon} />
            ) : (
                <span className={styles.memberCount}>{memberCount}</span>
            )}
        </div>
    );
};

export default PoolOption;
